// extracted by mini-css-extract-plugin
export var contentBody = "_dl-9";
export var headerImage = "_dl-2";
export var imageButton = "_dl-7";
export var imageButtonIcon = "_dl-8";
export var imageHeader = "_dl-4";
export var imageHeaderText = "_dl-5";
export var imageOverlay = "_dl-3";
export var imageTitle = "_dl-6";
export var imageWrapper = "_dl-1";
export var taskList = "_dl-a";
export var widget = "_dl-0";